'use client'

import React from 'react'
import type { Page } from '@/payload-types'
import { Eyebrow } from '@/components/Eyebrow'
import { Heading } from '@/components/ui/heading'
import { ShardGridWithElements } from '@/components/ShardGridWithElements'

export function BlogHero({ heading }: Page['hero']) {
  const elements = [
    {
      element: <Eyebrow variant="dark" color="slime" label="BLOG" />,
      position: {
        row: 1,
        col: 1,
        width: {
          default: '50%',
          sm: '50%',
          md: '20%',
          lg: '20%',
          xl: '15%',
          '2xl': '15%',
        },
      },
    },
    {
      element: (
        <Heading size="h1" asChild className="text-olive-1">
          <h2>{heading}</h2>
        </Heading>
      ),
      className: 'items-start md:items-center',
      position: {
        row: 3,
        col: 1,
        width: {
          default: '100%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          '2xl': '60%',
        },
      },
    },
  ]

  return (
    <div className="py-16 bg-paper-1 overflow-hidden">
      <div className="container mx-auto px-4 pb-[50px] md:pb-[40px]">
        <div className="h-[300px]">
          {/* SEO-only H1 since the actual heading takes a moment to load */}
          <h1 className="sr-only">{heading}</h1>
          <ShardGridWithElements elements={elements} className="w-full h-full" minGapSize={80} />
        </div>
      </div>
    </div>
  )
}
